import ByPersonCreateView from "../../backyard/view/person/Create.vue";
import ByPersonDetailView from "../../backyard/view/person/Detail.vue";
import ByPersonListView from "../../backyard/view/person/List.vue";


let lbPersonRouter = [];

let byPersonRouter = [
	{
		path: 'person/list',
		name: "byPersonList",
		component: ByPersonListView,
		meta: {
			requiresAuth: true,
			breadcrumbs: [
				{
					name: "byPersonList",
					title: "教学团队列表"
				}
			]
		}
	},
	{
		path: 'person/create',
		name: "byPersonCreate",
		component: ByPersonCreateView,
		meta: {
			requiresAuth: true,
			breadcrumbs: [
				{
					name: "byPersonList",
					title: "教学团队列表"
				},
				{
					name: "byPersonCreate",
					title: "创建教学团队"
				}
			]
		}
	},
	{
		path: 'person/edit/:id',
		name: "byPersonEdit",
		component: ByPersonCreateView,
		meta: {
			requiresAuth: true,
			breadcrumbs: [
				{
					name: "byPersonList",
					title: "教学团队列表"
				},
				{
					name: "byPersonEdit",
					title: "编辑教学团队"
				}
			]
		}
	},
	{
		path: 'person/detail/:id',
		name: "byPersonDetail",
		component: ByPersonDetailView,
		meta: {
			requiresAuth: true,
			breadcrumbs: [
				{
					name: "byPersonList",
					title: "教学团队列表"
				},
				{
					name: "byPersonDetail",
					title: "教学团队详情"
				}
			]
		}
	}
];


export {lbPersonRouter, byPersonRouter}





// WEBPACK FOOTER //
// ./src/common/router/PersonRouter.js